(function ($) {
    'use strict';

    $(function () {

        if (isMobileApp()) {
            onLinkClick();
        }

        init();

        let subscribeEventName = 'reinit__search-results';
        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, function (e, $searchResults) {
            console.log('event-received: ' + subscribeEventName);

            init($searchResults);
        });

    });

    function init($searchResults) {

        if (!$searchResults || !$searchResults.length) {
            return;
        }

        $searchResults.iScroll({
            loaderSelector: '.results__loader',
            navSelector: '.results__pagination',
            nextSelector: '.results__pagination:last .results__pagination__next-link:last',
            dataAttributeNextSelector: 'href',
            onFinish: function () {

            }
        });

    }

    /**
     * Обработчик события: клик по ссылке в результатах поиска
     *
     */
    function onLinkClick() {
        $(document).off('mousedown', '.results-item__title-link');
        $(document).on('mousedown', '.results-item__title-link', (e) => {
            let $resultsItem = $(e.target).parents('.results-item');

            $resultsItem.addClass('landing-loading');

            setTimeout(() => $resultsItem.removeClass('landing-loading'), 1000)
        });
    }

    /**
     * Определяет открыта страница в мобильно приложении или нет
     *
     */
    function isMobileApp() {
        return document.body.classList.contains('is-mobile-app');
    }

})(window.jQuery);